import { FiltersDataType, FiltersStateType } from "../models/filters";

export const exportFilterStateToSQ = (actualDataObj: FiltersStateType) => {
  let marketString = "";
  let productString = "";

  const dynamicFilters = actualDataObj.Dynamic.reduce((url, curr) => {
    if ("FromValue" in curr) {
      return (url += `${curr.Key},${curr.FromValue},${curr.ToValue};`);
    } else if (curr.Checked.length) {
      return (url += `${curr.Key},${curr.Checked.join()};`);
    } else {
      return url;
    }
  }, "");

  const topFilters = actualDataObj.TopSelected.reduce((url, curr) => {
    if (curr.Checked.length) {
      return (url += `${curr.Key},${curr.Checked.join()};`);
    } else {
      return url;
    }
  }, "");

  if (actualDataObj.Market && actualDataObj.Market.length) {
    marketString = `market,${actualDataObj.Market.join()};`;
  }
  if (actualDataObj.ProductGroup && actualDataObj.ProductGroup.length) {
    productString = `product,${actualDataObj.ProductGroup.join()};`;
  }

  const fullSearchString = `?${marketString}${productString}${dynamicFilters}${topFilters}`;
  if (window.history && window.history.pushState) {
    const oldPath = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
    const newurl = oldPath + fullSearchString;
    window.history.pushState({ path: newurl }, "", newurl);
  }
};

export const createFiltersFromSQ = (availableFilters: FiltersDataType) => {
  const updatedFilteringObject: FiltersStateType = {
    Dynamic: [],
    Market: [],
    ProductGroup: [],
    TopSelected: [],
  };

  const queryLoaded = window.location.search.substr(1);
  // ?market,1653;product,1455,1456;2577,0,13;2578,0,8;2573,2530,2527,2528;2574,2532;
  // slider: 2578,0,8
  // checkboxes: 2573,2530,2527,2528
  const queryArr = queryLoaded.split(";").filter(Boolean);
  /* eslint-disable-next-line array-callback-return */
  queryArr.map((queryEl) => {
    const group = queryEl.split(",");
    const groupId = group[0];
    const checkedInGroup = group.slice(1);

    if (groupId === "market") {
      updatedFilteringObject.Market = checkedInGroup;
    } else if (groupId === "product") {
      updatedFilteringObject.ProductGroup = checkedInGroup;
    } else {
      // Detect main vs dynamic
      const isMain = availableFilters.main.find((f) => f.Id === groupId);
      // const isDynamic = allFilters.dynamic.find(f => f.Id === groupId);
      // TODO parse checked Values against checkedInGroup to eliminate not available values
      if (isMain) {
        updatedFilteringObject.TopSelected.push({
          Key: groupId,
          Checked: checkedInGroup,
        });
      } else {
        updatedFilteringObject.Dynamic.push({
          Key: groupId,
          Checked: checkedInGroup,
        });
      }
    }
  });

  return updatedFilteringObject;
};
